"use strict";
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChatStatusType = void 0;
/**
 * chat状态 init,pending,success,error
 */
var ChatStatusType;
(function (ChatStatusType) {
    ChatStatusType["INIT"] = "init";
    ChatStatusType["PENDING"] = "pending";
    ChatStatusType["SUCCESS"] = "success";
    ChatStatusType["ERROR"] = "error";
})(ChatStatusType = exports.ChatStatusType || (exports.ChatStatusType = {}));
